import { useState, useEffect } from 'react';

export const DEMO_MESSAGES = [
  {
    id: 'demo-emily',
    sender_name: 'Emily',
    message_body: "May this beautiful day become a memory you'll always hold close to your heart. Wishing you a lifetime of love and laughter.",
  },
  {
    id: 'demo-daniel',
    sender_name: 'Daniel',
    message_body: "Here's to all the little moments that become the memories we treasure most. So happy to celebrate this special moment with you.",
  },
  {
    id: 'demo-sophie',
    sender_name: 'Sophie',
    message_body: "May your days together always be filled with kindness, laughter, and the comfort of knowing you have each other.",
  },
  {
    id: 'demo-marcus',
    sender_name: 'Marcus',
    message_body: "Wishing you many beautiful chapters ahead, filled with love, wonderful surprises, and moments worth remembering.",
  },
  {
    id: 'demo-chloe',
    sender_name: 'Chloe',
    message_body: "May this celebration be just the beginning of many happy memories made together. Sending you lots of love.",
  },
  {
    id: 'demo-ethan',
    sender_name: 'Ethan',
    message_body: "Some moments are meant to be remembered forever. So grateful to be here to share this one with you.",
  },
  {
    id: 'demo-olivia',
    sender_name: 'Olivia',
    message_body: "May you always find joy in the little things, warmth in each other, and plenty of reasons to smile along the way.",
  },
];

export function useDemoMessages(intervalMs = 5000, maxVisible = 7) {
  const [visibleMessages, setVisibleMessages] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => {
        const next = prev + 1;
        if (next > DEMO_MESSAGES.length) {
          setVisibleMessages([]);
          return 0;
        }
        const count = Math.min(next, maxVisible);
        setVisibleMessages(DEMO_MESSAGES.slice(0, count));
        return next;
      });
    }, intervalMs);

    setVisibleMessages([DEMO_MESSAGES[0]]);
    setCurrentIndex(1);

    return () => clearInterval(timer);
  }, [intervalMs, maxVisible]);

  return visibleMessages;
}